import * as $ from 'jquery';
import { getCookie, setCookie } from "../../js/utils";
class Header {
  init = () => {
    const $header = $('.header');
    $header.find('.header__nav__menu__level-01__btn').on('click', function (e) {
      e.stopPropagation();
      const menuOpen = $(this).siblings('.header__nav__menu__level-02').hasClass('header__nav__menu__level-02--active');
      // Remove class and close the  existing opened menu
      $('.header__nav__menu__container').removeClass('menu--active');
      $('.header__nav__menu__level-02').removeClass('header__nav__menu__level-02--active');
      if(menuOpen) {
       
        $(this).parents('.header__nav__menu__container').removeClass('menu--active');
        $(this).siblings('.header__nav__menu__level-02').removeClass('header__nav__menu__level-02--active');
      } else {
        $(this).parents('.header__nav__menu__container').addClass('menu--active');
        $(this).siblings('.header__nav__menu__level-02').addClass('header__nav__menu__level-02--active');
      }
    });

    $header.find('.header__nav__menu__level-02__accordion__btn').on('click', function (e) {
      e.stopPropagation();
      appHeight();
      const menuOpen = $(this).parents('.header__nav__menu__level-02__accordion').hasClass('menu-is-expanded');
      if(!menuOpen){
        $header.find('.menu-is-expanded')?.removeClass('accordion--is-expanded');
        $header.find(".menu-is-expanded .accordion__content").slideUp(0);
        setTimeout(() => {
            $header.find('.menu-is-expanded')?.removeClass('menu-is-expanded');
            $(this).parents('.header__nav__menu__level-02__accordion').addClass('menu-is-expanded');
          }, 500);
      }else{
        $(this).parents('.header__nav__menu__level-02__accordion').removeClass('menu-is-expanded');
        $header.find(".menu-is-expanded .accordion__content").slideDown(0);
      }
      
    });

    $header.find('.header__nav__menu__btn-detroy').on('click', function (e) {
      e.stopPropagation();
      const menuOpen = $header.find('.header__nav__menu__level-02__accordion').hasClass('menu-is-expanded');
      if(menuOpen){
        $header.find('.menu-is-expanded .header__nav__menu__level-02__accordion__btn').click();
      }
      $(this).parents('.header__nav__menu__level-02').removeClass('header__nav__menu__level-02--active');
      $(this).parents('.header__nav__menu__container').removeClass('menu--active');
    });

    // Event close level 2
    $header.find('.header__nav__menu__level-02__left__btn').on('click', function (e) {
      e.stopPropagation();
      const menuOpen = $header.find('.header__nav__menu__level-02__accordion').hasClass('menu-is-expanded');
      if(menuOpen){
        $header.find('.menu-is-expanded .header__nav__menu__level-02__accordion__btn').click();
      }else{
        $(this).parents('.header__nav__menu__level-02').removeClass('header__nav__menu__level-02--active');
        $(this).parents('.header__nav__menu__container').removeClass('menu--active');
      }
      
    });

    $header.find('.header__nav__hamburger').on('click', function (e) {
      e.stopPropagation();
      $('body').toggleClass("nav-active");
      $(this).siblings('.header__nav__menu').toggleClass('header__nav__menu--active');
      $(this).siblings('.header-nav-logo-menu').find('.header__nav__menu').toggleClass('header__nav__menu--active');
    });

    $header.find('.header__ribbon__dropdown, .header__ribbon__dropdown-menu__btn').on('click', function (e) {
      const modalActive =  $(this).parents('.header__ribbon__wrapper').hasClass('header__ribbon__wrapper__menu--active');
      $('.header__ribbon__wrapper').removeClass('header__ribbon__wrapper__menu--active');
      e.stopPropagation();
      if(modalActive) {
        $(this).parents('.header__ribbon__wrapper').removeClass('header__ribbon__wrapper__menu--active');
      } else {
        $(this).parents('.header__ribbon__wrapper').addClass('header__ribbon__wrapper__menu--active');
      }
    });

    $header.find('.header__nav__menu__level-01__item__wrapper').hover(function(){
      if($header.find('.header__nav__search').hasClass('')) {
        $header.find('.header__nav__search__btn').trigger('click');
      }
    });
    $(document).on('click', function (e) {
      $('.header__ribbon__wrapper').removeClass('header__ribbon__wrapper__menu--active');
      $header.removeClass('dropdown-menu--active');
      // In tablet close menu, when clicked outside
      if(e.target.contains($('.header__nav__menu__level-01__item').get(0))){
        $('.header__nav__menu__container').removeClass('menu--active');
        $('.header__nav__menu__level-02').removeClass('header__nav__menu__level-02--active');
      }
    });
    // Country selector
    $('.header__ribbon__region .header__ribbon__item__btn').on('click', function() {
        var previousCultureCode = getCookie("CustomSelectedCulture");
        var selectedCultureCode = $(this).attr("data-culture-code");
        if (selectedCultureCode !== "" && selectedCultureCode !== undefined) {
          setCookie("CustomSelectedCulture", selectedCultureCode, 365);
          if (previousCultureCode === selectedCultureCode) {
            return;
          }
          else if (previousCultureCode === "en-in") {
            window.location.href = window.location.href.replace("/en", "/" + selectedCultureCode);
          }
          else if (selectedCultureCode === "en-in") {
            window.location.href = window.location.href.replace("/" + previousCultureCode, "/en");
          }
          else {
            window.location.href = window.location.href.replace(previousCultureCode, selectedCultureCode);
          }
        }
      })


     // User clicked into the input
      $('.header__nav__search__form__input').on('click', function (e) {
         const wrapper = $(this).parents('.header__nav__search__form__wrapper');
         const placeholder = wrapper.find('.placeholder');
         placeholder.addClass("d-none");
         $(this).css("opacity", "1");
      });

      //User typed
      $('.header__nav__search__form__input').on('input', function (e) {
        const wrapper = $(this).parents('.header__nav__search__form__wrapper');
         const placeholder = wrapper.find('.placeholder');
         $(this).val()?.toString().trim() === "" ?  placeholder.removeClass("d-none") : placeholder.addClass("d-none");
        $(this).val()?.toString().trim() === "" ? $(this).css("opacity", "0") : $(this).css("opacity", "1");
       
        
      });

      //User left the input
      $('.header__nav__search__form__input').on('blur', function (e) {
         const wrapper = $(this).parents('.header__nav__search__form__wrapper');
         const placeholder = wrapper.find('.placeholder');
         $(this).val()?.toString().trim() === "" ?  placeholder.removeClass("d-none") : placeholder.addClass("d-none"); //placeholder
         $(this).val()?.toString().trim() === "" ? $(this).css("opacity", "0") : $(this).css("opacity", "1")
        
      });

      $('.header__nav__search__form__search__btn_close').on('click', function () {
        $('.header__nav__search__form__input').val(''); // Clear the input
        $('.header__nav__search__form__input').trigger('input'); // Optionally trigger 'input' event if needed
      });


      $('.header__nav__hamburger-trigger').on('click', function () {
        $('.header__nav__hamburger').click();
        const btnEl = $(this).find('.header__nav__hamburger__icon');
        const btnClose = btnEl?.hasClass('fa-bars');

        if(btnClose){
          btnEl?.removeClass('fa-bars');
          btnEl?.addClass('fa-close');
      
        }else{
          btnEl?.addClass('fa-bars');
          btnEl?.removeClass('fa-close');
        }

      })

      $('.header__shopping-count-search .header__nav__search-icon').on('click', function () {
         const $searchField = $('#headerSearchField');
        $('.header__nav__search__form__input')?.click();
        
            if ($(this).hasClass('visible-icon')) {
              $searchField[0]?.blur();
      
            }else{
              $('#headerSearchField').val('');
              $searchField[0]?.focus();
            
            }
        
      })

      $('.header__nav__search-icon').on('click', function () {
        const searchOpenIcon = $(this).hasClass('visible-icon');
        const placeholder = $('.header__nav__search__form .placeholder').hasClass("d-none");

        if(placeholder){
            $('.header__nav__search__form .placeholder').addClass("d-none");
        }
        if(searchOpenIcon){
          $('.header__nav__search-icon').removeClass('visible-icon');
          $('.header__nav__search').removeClass('visible')
        }else{
          $('.header__nav__search-icon').addClass('visible-icon');
          $('.header__nav__search').addClass('visible')
        }

        setTimeout(() => {
          appHeight();
        }, 500);
      })
  }
}
const appHeight = () => {
  const visibleSiteWide = $('.site-wide-banner.visible');
  let reset: number = 0;
  const doc = document.documentElement
  const header = $('.header .header__nav').outerHeight();
  const headerRibbon = $('.header__ribbon.desktop-only').outerHeight();
  const headersideWide =  visibleSiteWide.length > 0 ? $('.site-wide-banner.visible').outerHeight(true) : reset ;
  $('.header')[0]?.style.setProperty('--header-height', `${header}px`);
  $('.header')[0]?.style.setProperty('--header-ribbon-height', `${headerRibbon + headersideWide}px`)
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
}

window.addEventListener('scroll', function () {

  if (window.scrollY > 0) {
    $('.header')[0]?.classList.add('scrolled');
    $('.header__nav__search').removeClass('visible-scroll');
    $('.site-wide-banner').removeClass('visible');

  } else {
    $('.header__nav__search').addClass('visible-scroll')
    $('.header')[0]?.classList.remove('scrolled');
    $('.site-wide-banner').addClass('visible');  
   
  }
  setTimeout(() => {
    appHeight();
  }, 800);
  
});


window.addEventListener('resize', function () {
  appHeight();

  setTimeout(() => {
    appHeight();
  }, 500);

})


appHeight();

const HeaderInstance = new Header();
HeaderInstance.init();
export { Header, HeaderInstance };